var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.errorserver) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "error__inner"
  }, [_c('div', {
    staticClass: "error__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.errorserver.text_error_status)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error__text",
    domProps: {
      "innerHTML": _vm._s(_vm.page.errorserver.text_error_title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.errorserver.text_error_text)
    }
  })])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b44000e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ErrorServer.vue
// module id = 186
// module chunks = 0